export const PRIMARY_CLASS = 'primary';
export const PROGRESSBAR = {
	COLOR: PRIMARY_CLASS,
	MODE: 'indeterminate',
	VALUE: 50,
	BUFFER_VALUE: 20,
};

export const ACCOUNT_TYPE = {
	CARRIER: 'CARRIER',
	BROKER: 'BROKER',
	ADMIN: 'ADMIN',
	SHIPPER: 'SHIPPER',
	PARTNER: 'PARTNER',
	OWNER: 'OWNER',
	USER: 'USER',
};

export const BID_ACTION_TEXT = {
	ACCEPT: 'Accept',
	COUNTER: 'Counter',
	UPDATE: 'Update',
	BOOK_NOW: 'Book Now',
};

export const API_PATH = {
	ASCEND_TMS: 'ascend-tms',
	ASCEND: 'ASCEND',
	CARRIER_HUB_API: 'carrier?carrierHubId',
	REGISTER_DEVICE_API: 'registerDevice',
	TOP_SEARCHES: 'topSearches',
};

export const APP_ENV = {
	PROD: 'prod',
	STAGING: 'staging',
};

export const CHIP_CLASSES = {
	ACCEPTED: 'accepted-chip',
	SELECTED: 'selected-chip',
};

export const ACCOUNT_SETTINGS = {
	BCC_USER_OFFERS: 'BCC_USER_OFFERS',
	DECLARED_VALUE_REQUIRED: 'DECLARED_VALUE_REQUIRED',
	DEFAULT_TO_MY_PROJECTS: 'DEFAULT_TO_MY_PROJECTS',
	DELIVERY_APPOINTMENT_REQUIRED: 'DELIVERY_APPOINTMENT_REQUIRED',
	DEMO_ACCOUNT: 'DEMO_ACCOUNT',
	FREQUENCY_ENABLED: 'FREQUENCY_ENABLED',
	IS_FEEDBACK_ENABLED: 'IS_FEEDBACK_ENABLED',
	PICK_UP_APPOINTMENT_REQUIRED: 'PICK_UP_APPOINTMENT_REQUIRED',
	PROJECT_PROBABILITY: 'PROJECT_PROBABILITY',
	PROJECT_PROBABILITY_SETTINGS: 'PROJECT_PROBABILITY_SETTINGS',
	SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT: 'SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT',
	SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT: 'SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT',
	SEARCH_TRUCK_PICKUP_DATE_RANGE: 'SEARCH_TRUCK_PICKUP_DATE_RANGE',
	SEARCH_TRUCK_RESULTS_COUNT: 'SEARCH_TRUCK_RESULTS_COUNT',
	SEARCHABLE_TRAILER_TYPES: 'SEARCHABLE_TRAILER_TYPES',
	SEND_RATE_CON: 'SEND_RATE_CON',
	TARGET_MARGIN: 'TARGET_MARGIN',
	TRUCK_SEARCH_ENABLED: 'TRUCK_SEARCH_ENABLED',
	WEIGHT_REQUIRED: 'WEIGHT_REQUIRED',
	ANNUAL_VOLUME: 'ANNUAL_VOLUME',
	SCORECARDS: 'SCORECARDS',
	CUSTOMERS: 'CUSTOMERS',
	CARRIER_RATES: 'CARRIER_RATES',
	POST_LOAD: 'POST_LOAD',
	VOLUME_REQUIRED: 'VOLUME_REQUIRED',
	PROJECTS_BOARD: 'PROJECTS_BOARD',
	USER_ENABLED_PROJECT_BOARD: 'USER_ENABLED_PROJECT_BOARD',
	MCLEOD_INTEGRATION: 'MCLEOD_INTEGRATION',
	HAZMAT: 'HAZMAT',
	STRONG_LANES: 'STRONG_LANES',
	STRONG_LANES_SETTINGS: 'STRONG_LANES_SETTINGS',
	TEAMS_CAPACITY: 'TEAMS_CAPACITY',
	BOOKING_ASSISTANT: 'BOOKING_ASSISTANT',
	CUSTOMIZABLE_EMAILS: 'CUSTOMIZABLE_EMAILS',
	EMAIL_ROUTING: 'EMAIL_ROUTING',
	CONFIDENCE_SCORE: 'CONFIDENCE_SCORE',
	SEND_LOADS_WITH_NO_RATE: 'SEND_LOADS_WITH_NO_RATE',
	RATE_RECENCY_LIMIT: 'RATE_RECENCY_LIMIT',
	GET_OPTION_VISIBLE: 'GET_OPTION_VISIBLE',
	PICKUP_DATE_THRESHOLD: 'PICKUP_DATE_THRESHOLD',
	PARTIAL_LOAD_ENABLED: 'PARTIAL_LOAD_ENABLED',
	AMAZON_FREIGHT: 'AMAZON_FREIGHT',
	BOOKING_ASSISTANT_AUTOMATION_ENABLED: 'BOOKING_ASSISTANT_AUTOMATION_ENABLED',
	// CN-8994: CargoChief-controlled gate on whether the account may turn the ENABLED setting on.
	BOOKING_ASSISTANT_AUTOMATION_ALLOWED: 'BOOKING_ASSISTANT_AUTOMATION_ALLOWED',
	ROLE_BASED_CUSTOMER_DATA_ACCESS: 'ROLE_BASED_CUSTOMER_DATA_ACCESS',
	BA_PERFORMANCE_METRICS_ENABLED: 'BA_PERFORMANCE_METRICS_ENABLED',
	CARRIER_QUALITY: 'CARRIER_QUALITY',
	ENABLE_OUT_OF_NETWORK_CARRIERS: 'ENABLE_OUT_OF_NETWORK_CARRIERS',
	GREENSCREENS_RATE_IN_RFP: 'GREENSCREENS_RATE_IN_RFP',
	CAPACITY_DATA_IN_RFP: 'CAPACITY_DATA_IN_RFP',
	BULK_RATING_ENABLED: 'BULK_RATING_ENABLED',
	AUTO_INVITE_CARRIERS: 'AUTO_INVITE_CARRIERS',
	USE_RECENT_LANE_SEARCHES: 'USE_RECENT_LANE_SEARCHES',
	SHOW_LOADS_PREDICTED_PRICE: 'SHOW_LOADS_PREDICTED_PRICE',
	INCLUDE_DISPATCHER_IN_BOOK_NOW_OFFER: 'INCLUDE_DISPATCHER_IN_BOOK_NOW_OFFER',
	HIDE_CUSTOMER_DETAILS_FROM_NON_ADMIN_USERS: 'HIDE_CUSTOMER_DETAILS_FROM_NON_ADMIN_USERS',
	NON_ADMIN_SEE_OWN_LOADS_ONLY: 'NON_ADMIN_SEE_OWN_LOADS_ONLY',
	LANE_ANALYTICS: 'LANE_ANALYTICS',
	LANE_CARRIER_ANALYTICS: 'LANE_CARRIER_ANALYTICS',
	WORKFLOW_PERFORMANCE_REPORT: 'WORKFLOW_PERFORMANCE_REPORT',
	PROCUREMENT_VERSIONS: 'PROCUREMENT_VERSIONS',
	DASHBOARD_VERSIONS: 'DASHBOARD_VERSIONS',
	TOP_CARRIERS_ENABLED: 'TOP_CARRIERS_ENABLED',
	RECOMMENDED_CARRIERS_RANK_CAP: 'RECOMMENDED_CARRIERS_RANK_CAP',
	RECOMMENDED_CARRIERS_LANE_CAP: 'RECOMMENDED_CARRIERS_LANE_CAP',
	RECOMMENDED_CARRIERS_COOLDOWN_WEEKS: 'RECOMMENDED_CARRIERS_COOLDOWN_WEEKS',
};

export const USER_SETTINGS = {
	SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT: 'SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT',
	SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT: 'SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT',
	DEFAULT_TRAILER_TYPES: 'DEFAULT_TRAILER_TYPES',
	MINIMUM_FREQUENCY: 'MINIMUM_FREQUENCY',
	MINIMUM_TRUCK_COUNT: 'MINIMUM_TRUCK_COUNT',
	DEFAULT_PICK_UP_DATE_TYPE: 'DEFAULT_PICK_UP_DATE_TYPE',
	DEFAULT_CAPACITY_SEARCH_TAB: 'DEFAULT_CAPACITY_SEARCH_TAB',
	BOOKING_ASSISTANT: 'BOOKING_ASSISTANT',
	HIDE_ENGAGE_CARRIER_DIALOG: 'HIDE_ENGAGE_CARRIER_DIALOG',
	PROCUREMENT_VERSION_PREFERENCE: 'PROCUREMENT_VERSION_PREFERENCE',
	DASHBOARD_VERSION_PREFERENCE: 'DASHBOARD_VERSION_PREFERENCE',
};

export const PROCUREMENT_VERSION = {
	COLLAPSIBLE: 'COLLAPSIBLE',
	KANBAN: 'KANBAN',
};

export const PROCUREMENT_VERSION_OPTIONS = [
	{ label: 'Collapsible', value: PROCUREMENT_VERSION.COLLAPSIBLE },
	{ label: 'Kanban', value: PROCUREMENT_VERSION.KANBAN },
];

// CN-8712 — default dashboard layout preference (mirrors PROCUREMENT_VERSION).
export const DASHBOARD_VERSION = {
	CURRENT: 'CURRENT',
	V2: 'V2',
};

export const DASHBOARD_VERSION_OPTIONS = [
	{ label: 'Current', value: DASHBOARD_VERSION.CURRENT },
	{ label: 'V2', value: DASHBOARD_VERSION.V2 },
];

export const CARGOCHIEF_KEYS = {
	ACTIVE_ONLY: 'activeOnly',
	ASCEND_BID_DETAILS: 'ascendBidDetails',
	LAYOUT_SETTING: 'layoutSetting',
	CUSTOMER_FEEDBACK_LIST: 'customerFeedbackList',
	CARRIER_FEEDBACK_FROM_DB_LIST: 'carrierFeedbackListFromDB',
	CARRIER_SELECTED: 'carrierSelected',
	TOP_SEARCHES: 'topSearch',
	TRUCK_FILTER_VALUE: 'truckFilterValue',
	CAPACITY_FILTER_SORT: 'capacityFilterSort',
	ORIGIN_DEADHEAD_SLIDER: 'ORIGIN_DEADHEAD_SLIDER',
	DESTINATION_DEADHEAD_SLIDER: 'DESTINATION_DEADHEAD_SLIDER',
	TRUCK_FILTER: 'filterSelected',
	CARRIER_HQ_FILTER: 'carrierHQ',
	FREQUENCY_FILTER: 'FREQUENCY_FILTER',
	PAYMENT_AMOUNT: 'PAYMENT_AMOUNT',
	DELAY_REGISTRATION: 'DELAY_REGISTRATION',
	NAME_ON_PAYMENT_CARD: 'NAME_ON_PAYMENT_CARD',
	IS_TYPEFORM_FEEDBACK: 'IS_TYPEFORM_FEEDBACK',
	NO_OF_USERS: 'NO_OF_USERS',
	NEW_REGISTRATION: 'NEW_REGISTRATION',
	SET_PASSWORD: 'SET_PASSWORD',
	SURVEYS: 'SURVEYS',
	IS_FULL_PROFILE_OPENED: 'IS_FULL_PROFILE_OPENED',
	ACCOUNT_CARRIER_MAP_COUNT: 'ACCOUNT_CARRIER_MAP_COUNT',
	LOGGED_IN: 'LOGGED_IN',
	DEFAULT_CUSTOMERS_LIST: 'DEFAULT_CUSTOMERS_LIST',
	PROJECT_IDS: 'PROJECT_IDS',
	PROJECT_IDS_TO_LIST: 'PROJECT_IDS_TO_LIST',
	CURRENT_PROJECT_PAGE: 'CURRENT_PROJECT_PAGE',
	FEEDBACK_COUNT: 'FEEDBACK_COUNT',
	SCORECARD_DATE_RANGE: 'SCORECARD_DATE_RANGE',
	MY_CARRIER_PACKETS: 'MY_CARRIER_PACKETS',
	HIGHWAY: 'HIGHWAY',
	MCLEOD: 'MCLEOD',
	NEXT_PAYMENT_DATE_EXPIRED: 'NEXT_PAYMENT_DATE_EXPIRED',
	USER_CARRIER_MAPS: 'USER_CARRIER_MAPS',
	UPDATE_PROFILE: 'UPDATE_PROFILE',
	ACCOUNT_USERS: 'ACCOUNT_USERS',
	CARRIERS_CSV_UPLOADED: 'CARRIERS_CSV_UPLOADED',
	NOTIFICATION_SETTINGS: 'NOTIFICATION_SETTINGS',
	CARRIER: 'CARRIER',
	LOGIN_SETUP_LAST_UPDATE: 'LOGIN_SETUP_LAST_UPDATE',
	INTEGRATION_TYPES: 'INTEGRATION_TYPES',
	BA_CONFIG: 'BA_CONFIG',
	ONBOARDED_CARRIERS: 'ONBOARDED_CARRIERS',
	INTEGRATIONS_TYPE: 'INTEGRATIONS_TYPE',
	ACTIVE_INTEGRATIONS: 'ACTIVE_INTEGRATIONS',
	PWA_INSTALL_DISMISSED: 'PWA_INSTALL_DISMISSED',
	PROJECT_DETAILS_FILTERS: 'PROJECT_DETAILS_FILTERS',
};

export const NOTIFICATION_NAMES = {
	BidAcceptCommand: 'BidAcceptCommand',
	BookingSignatureEmailCommand: 'BookingSignatureEmailCommand',
	BidCounterEmailCommand: 'BidCounterEmailCommand',
	BidDeclineCommand: 'BidDeclineCommand',
	brokerRateConfirmation: 'brokerRateConfirmation',
	brokerCounter: 'brokerCounter',
	brokerBookingConfirmation: 'brokerBookingConfirmation',
	BookingConfirmationEmailCommand: 'BookingConfirmationEmailCommand',
};

export const ACIVITY_TYPE_MESSAGES = {
	BidAcceptCommand: 'carrier accepted bid',
	BookingSignatureEmailCommand: 'rate confirmation was signed by the carrier',
	BidCounterEmailCommand: 'carrier countered bid',
	BidDeclineCommand: 'carrier declined bid',
	brokerRateConfirmation: 'rate confirmation was sent to the carrier',
	brokerCounter: 'counter sent to ',
	brokerBookingConfirmation: 'booking confirmation submitted',
};

export const INDEXED_DB = {
	BIDS: 'bids',
	LAYOUT: 'layout',
	DASHBOARD: 'dashboard',
	DASHBOARD_SETTING: 'dashboard_setting',
	LOAD_SOURCING_INSTRUCTIONS: 'load_sourcing_instructions',
};

export const PLAN_NAMES = {
	STANDARD: 'STANDARD',
	PRO: 'PRO',
	LITE: 'LITE',
	LANE_MASTER: 'LANE_MASTER',
	STANDARD_PLUS_PRICING: 'STANDARD_PLUS_PRICING',
	PRO_PLUS_PRICING: 'PRO_PLUS',
	ENTERPRISE: 'ENTERPRISE',
	ENTERPRISE_1: 'ENTERPRISE 1',
	ENTERPRISE_2: 'ENTERPRISE 2',
	PRICING: 'PRICING',
	CARRIER: 'CARRIER',
	CARRIER_PLUS_PRICING: 'CARRIER_PLUS_PRICING',
	// Carrier Plans
	CARRIER_BASIC: 'CARRIER_BASIC',
	CARRIER_PRO: 'CARRIER_PRO',
	// API Plans
	API_STARTER: 'API_STARTER',
	API_GROWTH: 'API_GROWTH',
	API_POWER: 'API_POWER',
	// App Plans
	APP_STARTER: 'APP_STARTER',
	APP_GROWTH: 'APP_GROWTH',
	APP_POWER: 'APP_POWER',
	// Automation Plan
	AUTOMATION: 'AUTOMATION',
};

export const REGISTRATION_ERRORS = {
	ALREADY_REGISTERED_EMAIL: 'This email address is already registered with C4',
	CARRIER_ACCOUNT_ALREADY_EXISTS: 'An account already exists for this email. Please login.',
	EMAIL_IN_USE: 'Email is already in use.',
	DUPLICATE_ACCOUNT:
		'There is already an Account for the MC/DOT, please contact the Account Admin to get your account setup.',
	INVALID_CARRIER_PLAN:
		'Carrier can only register with Pricing, Carrier or Carrier with Pricing plan.',
	IS_CARRIER_CONTACT: 'A carrier contact exists with this email',
	CARRIER_VALIDATION_FAILED:
		'Currently access is limited to carriers that are working with Cargo Chief customers.',
	CARRIER_EMAIL_VALIDATION_FAILED: 'Cannot validate carrier email',
	CARRIER_NOT_FOUND: 'MC or DOT could not be verified. Please contact support@cargochief.com.',
	IP_OUTSIDE_US:
		"Account registration is currently limited to US-based carriers. If you're located outside the US, please contact our support team to learn about alternative solutions that might work for you.",
	REGISTRATION_ATTEMPT_LIMIT_REACHED:
		'You have reached the maximum number of registration attempts. Please contact support.',
};

export const SEARCH_FILTERS = {
	ALL_CARRIERS: 'All Carriers',
	MY_CARRIERS: 'My Carriers',
	OUT_OF_NETWORK_CARRIERS: 'Out of Network Carriers',
	ALL_CAPACITY: 'All Capacity',
	TRUCKS_ONLY: 'Trucks Only',
};

export const CAPACITY_SEARCH_FILTER = {
	CARRIERS: [SEARCH_FILTERS.ALL_CARRIERS, 'My Carriers', SEARCH_FILTERS.OUT_OF_NETWORK_CARRIERS],
	TRUCKS: ['All Capacity', 'Trucks Only'],
	CARRIER_HQ: ['Headhaul', 'Backhaul'],
};

export const RANGE_FILTERS = {
	SORT: {
		MATCH: 'match',
		FREQUENCY: 'frequency',
		DISTANCE_FROM_HQ: 'distance',
		QUALITY: 'quality',
	},
};

export const DESTINATION_TYPES = {
	CITY: 'CITY',
	REGION: 'REGION',
	STATES: 'STATES',
};

export const CARRIER_FEEDBACK_SETTINGS = {
	PAGE_SIZE: 3,
};

export const UPGRADE_TO_PRO_MSG = {
	SEE_MORE_RESULTS: `<span>
		Want to see more carriers for this lane, find out how&nbsp;
		<a target="_blank" href="https://www.cargochief.com/pricing/">
			<b><u>our Pro plan can help!</u></b>
		</a></span>`,
	MY_CARRIERS_FILTER: `<span>
		Not seeing the carriers you normally work with,&nbsp;
		<a target="_blank" href="https://www.cargochief.com/pricing/">
			<b><u>upgrade to Pro </u></b>
		</a>
		and we will get them onboard.</span>`,
};

export const BUCKET_NAMES = {
	BULK_CARRIER: 'cargochief-bulk-carrier',
};

export const PLAN_PRODUCTS = {
	BOOKING_ASSISTANT: 'Booking Assistant',
	BOOKING_ASSISTANT_API: 'Booking Assistant API',
	C4: 'C4',
	PRICING: 'Pricing',
	C4_API: 'C4 API',
	BULK_MATCHING: 'Bulk Matching',
	CARRIER_RECRUITING: 'CARRIER_RECRUITING',
	CAPACITY_SEARCH: 'CAPACITY_SEARCH',
	CARRIER_DEVELOPMENT: 'CARRIER_DEVELOPMENT',
	PROJECT_CARRIERS: 'PROJECT_CARRIERS',
	CARRIER_PROFILES: 'CARRIER_PROFILES',
	MULTIPLE_USERS: 'MULTIPLE_USERS',
	TASKS: 'TASKS',
	ASSIGN_CARRIERS: 'ASSIGN_CARRIERS',
	RECENT_TRANSACTIONS: 'RECENT_TRANSACTIONS',
	RFP: 'RFP',
	SCORECARDS: 'SCORECARDS',
	CUSTOMERS: 'CUSTOMERS',
	INTEGRATIONS: 'INTEGRATIONS',
	CARRIER_RATES: 'CARRIER_RATES',
	HAZMAT: 'HAZMAT',
	STRONG_LANES: 'STRONG_LANES',
	CUSTOMIZABLE_EMAILS: 'CUSTOMIZABLE_EMAILS',
};

export const ACCOUNT_STATUS = {
	PENDING: 'PENDING',
	ACTIVE: 'ACTIVE',
	INACTIVE: 'INACTIVE',
};

export const STRIPE_ERROR_CODES = {
	card_declined: 'card_declined',
};

export const STRIPE_ERROR_MESSAGES = {
	card_declined:
		'Your card was declined by our bank. Please verify all your card information and submit the form again. If the problem continues please contact customercare@cargochief.com',
};

export const COPY_TO_CLIPBOARD_MSGS = {
	MC: 'MC copied successfully.',
	DOT: 'DOT copied successfully.',
	API_TOKEN: 'API token copied successfully.',
	CUSTOMER_CODE: 'Customer code copied successfully.',
	BLUE_YONDER_CODE: 'Code copied',
	DFM_WEBHOOK: 'Webhook copied',
	EMAIL: 'Email address copied successfully.',
	FROM_EMAIL: 'From email copied successfully.',
};

export const S3_CSV_TEMPLATE = {
	BULK_MATCH: 'https://c4-shared-files.s3.us-west-1.amazonaws.com/active_loads_template.csv',
	BULK_PROJECTS: 'https://c4-shared-files.s3.us-west-1.amazonaws.com/bulk_project_template.csv',
	BULK_CARRIERS: 'https://c4-shared-files.s3.us-west-1.amazonaws.com/bulk_carrier_template.csv',
	BULK_EXCLUDED_CARRIERS:
		'https://c4-shared-files.s3.us-west-1.amazonaws.com/bulk_carrier_exclude_template.csv',
	PRICING_DATA: 'https://c4-shared-files.s3.us-west-1.amazonaws.com/historical_load_template.csv',
	RFP_TEMPLATE: 'https://c4-shared-files.s3.us-west-1.amazonaws.com/rfp_template.csv',
	BULK_BROKERS: 'https://c4-shared-files.s3.us-west-1.amazonaws.com/bulk_broker_template.csv',
};

export const TOOLTIP_MSG = {
	LAST_BID: `Last Bid is the last amount you bid for this project. It will appear once you add more data.`,
	BEST_RATE: `Best rate will show the best rate you have from a carrier for this project. It will appear once you add more data.`,
	PROJETED_MARGIN: `Projected Margin is calculated based on your previous bids and the best rates you have from carriers. It will appear as you add more data.`,
	TARGET_MARGIN: (margin): string =>
		`The target margin for the project is below the suggested target of ${margin}%`,
	OPPORTUNITY_VALUE: 'Opportunity Value = Annual Volume * Customer Rate',
	LOAD_VOLUME: (annualVolumeTooltip): string => `Load Volume: ${annualVolumeTooltip}`,
};

export const DEADHEAD_MSG: string =
	'The current rates are based on a radius of #radius# miles. The recent transactions being displayed are based on the Origin/Deadhead settings you have selected, there may be some variation between the recent transaction rates and the predicted rates.';

export const RECENT_TRANSACTION_SORT = {
	PICKUP_DATE: 'pickupDate',
	DEADHEAD_DIFF: 'deadheadDiff',
};

export const TERMS_AND_CONDITIONS_URL = {
	NON_ASCEND: 'https://c4-shared-files.s3-us-west-1.amazonaws.com/termsAndConditionsNonAscend.pdf',
};

export const PROJECT_PRIORITIES_OPTIONS: Array<any> = [
	{
		label: 'C4 Coverage',
		value: 'c4Coverage',
		assignedPriority: 1,
		tooltip: `Prioritize projects that will expand your carrier network`,
	},
	{
		label: 'Load Volume',
		value: 'loadVolume',
		assignedPriority: 2,
		tooltip: `Prioritize projects by the customer load volume`,
	},
	{
		label: 'Network Coverage',
		value: 'networkCoverage',
		assignedPriority: 3,
		tooltip: `Prioritize projects you have coverage for`,
	},
	{
		label: 'Projects Due Date',
		value: 'dueDate',
		assignedPriority: 4,
		tooltip: `projects will be prioritized by due date`,
	},
	{
		label: 'Projects is Awarded',
		value: 'awarded',
		assignedPriority: 5,
		tooltip: `Prioritize projects that have been awarded`,
	},
];

export const SCORECARDS_SVG_CLASS_NAME: any = {
	COUNT: 'count-circle-progress-subtitle',
	REVENUE: 'revenue-circle-progress-subtitle',
	ALL_IN_COST: 'cost-circle-progress-subtitle',
	FORECAST_BUY: 'forecast-buy-circle-progress-subtitle',
	MARGIN: 'margin-circle-progress-subtitle',
	EXPECTED_MARGIN: 'expected-margin-circle-progress-subtitle',
};

export const INTEGRATIONS: any = {
	MY_CARRIER_PACKETS: 'myCarrierPackets',
	MCLEOD: 'mcleod',
};

export const SURVEY_TYPE: any = {
	ONBOARDING: 'ONBOARDING',
	SURVEY: 'SURVEY',
};

export const NOTIFICATIONS: any = {
	BA_BID_ACCEPTED: 'BA_BID_ACCEPTED', // email sent to user and firebase notification sent to user and carrier
	BA_BID_COUNTER: 'BA_BID_COUNTER', // email sent to user and firebase notification sent to user and carrier
	BA_BID_DECLINE: 'BA_BID_DECLINE', // email sent to user and firebase notification sent to user and carrier
	BA_ACCEPT_RECOMMENDED: 'BA_ACCEPT_RECOMMENDED', // CN-8626: BA negotiated an acceptable offer (auto-book off) — email/desktop to broker to accept
	BA_REPLY_RECEIVED: 'BA_REPLY_RECEIVED', // email sent to user and firebase notification sent to user when carrier replies

	BA_BOOKING_CONFIRMED_BROKER: 'BA_BOOKING_CONFIRMED_BROKER', // email and firebase notification sent to user
	BA_BOOKING_SIGNATURE: 'BA_BOOKING_SIGNATURE', // email sent to carrier and firebase notification sent to user and carrier
	BA_BOOKING_SIGNATURE_BROKER: 'BA_BOOKING_SIGNATURE_BROKER',
	BA_LOAD_OWNER_UPDATE: 'BA_LOAD_OWNER_UPDATE', // email, web socket notification sent when carrier user clicks action: "update load owner"
	MULTIPLE_BIDDING: 'MULTIPLE_BIDDING', // email and push notification sent to broker/shipper when carrier counters multiple bids

	// BA_LOAD_BOOKED: 'BA_LOAD_BOOKED', // email sent to carrier and firebase notification sent to user and carrier
	BA_LOAD_CANCEL: 'BA_LOAD_CANCEL', // email and firebase notification sent to user

	PROJECT_BEST_RATE_UPDATED: 'PROJECT_BEST_RATE_UPDATED', //email and notification sent to user
	PROJECT_OWNER: 'PROJECT_OWNER', //email and notification sent to user
	PROJECT_RATE_RECEIVED: 'PROJECT_RATE_RECEIVED', // email sent to carrier and firebase notification sent to all users of account
	PROJECT_RATE_REQUEST: 'PROJECT_RATE_REQUEST', // email sent to carrier - TODO - remove
	RFP_CARRIER_NOT_AVAILABLE: 'RFP_CARRIER_NOT_AVAILABLE', // email sent to user and firebase notification sent to all users of account
	PROJECT_CARRIER_PROCURED: 'PROJECT_CARRIER_PROCURED', // email and notification sent to user and assignee
	CHECK_PROJECT: 'CHECK_PROJECT', // email and notification sent to project assignee if not then user

	TASK_ASSIGNED: 'TASK_ASSIGNED', // email and firebase notification sent to user
	USER_ASSIGNED_TO_CARRIER: 'USER_ASSIGNED_TO_CARRIER', // email and firebase notification sent to user

	MY_CARRIER_PACKETS: 'MY_CARRIER_PACKETS',
	CARRIER_EXCLUDED: 'CARRIER_EXCLUDED', // email and firebase notification send to all users of account when a carrier is excluded
	LOAD_FILE_RECEIVED: 'LOAD_FILE_RECEIVED', // email and firebase notification send to all users of account when a loads file is received
	CARRIER_ONBOARDING_REQUESTED: 'CARRIER_ONBOARDING_REQUESTED', // email and firebase notification sent to user when carrier initiates onboarding from the available load

	// carrier notifications
	EMAIL_MAPPED_CARRIER: 'EMAIL_MAPPED_CARRIER', //email sent to carrier TODO: safe to remove this

	NEW_BROKER_CONNECTED: 'NEW_BROKER_CONNECTED', // notifications sent to carriers when a new ACM created with broker or shipper
	BA_BID_CANCEL: 'BA_BID_CANCEL', // email sent to carrier and firebase notification sent to user and carrier
	BA_BID_INVITE: 'BA_BID_INVITE', // email and notification sent to carrier
	BA_BOOKING_CONFIRMATION: 'BA_BOOKING_CONFIRMATION', // email sent to carrier and firebase notification sent to user and carrier
	BA_BOOKING_CONFIRMED_CARRIER: 'BA_BOOKING_CONFIRMED_CARRIER', // email sent to carrier
	BA_LOAD_UPDATED: 'BA_LOAD_UPDATED', //email sent to carrier
	BA_BROKER_BID_COUNTER: 'BA_BROKER_BID_COUNTER', // notifications sent to carrier when broker counter
	BA_BID_SELECT: 'BA_BID_SELECT', // when broker selects carrier send notifications to carrier users
	BA_LOAD_BOOKED_CARRIER: 'BA_LOAD_BOOKED_CARRIER', //  notifications sent to carrier when load is booked
	BA_BOOKING_SIGNATURE_CARRIER: 'BA_BOOKING_SIGNATURE_CARRIER',
	BA_BOOKING_CONFIRMATION_CARRIER: 'BA_BOOKING_CONFIRMATION_CARRIER',
};

export const USER_ROLES: any = {
	INTERNAL: 'INTERNAL',
	EXTERNAL: 'EXTERNAL',
	BROKER: 'BROKER',
	CARRIER: 'CARRIER',
	SHIPPER: 'SHIPPER',
	OWNER: 'OWNER',
	ADMIN: 'ADMIN',
	USER: 'USER',
	CARRIER_RECRUITER: 'CARRIER_RECRUITER',
	CARRIER_RECRUITING_ADMIN: 'CARRIER_RECRUITING_ADMIN',
	EMAIL_EDITOR: 'EMAIL_EDITOR',
	DISPATCH_USER: 'DISPATCH',
	CC_RECIPIENT: 'CC_RECIPIENT',
		CUSTOMER_REVIEWER: 'CUSTOMER_REVIEWER',
	MANAGER: 'MANAGER',
};

export const PROJECT_BID_LABEL = {
	BID: 'Bid',
	UPDATE_BID: 'Update Bid',
	COUNTER_AVAILABLE: 'Counter Available',
};

export const URLS = {
	HELP_CENTER: 'https://intercom.help/C4-help/en/',
	CONTACT_US: 'https://cargochief.com/contact-us/',
};

export const BILLING_PERIOD = {
	DAILY: 'DAILY',
	WEEKLY: 'WEEKLY',
	MONTHLY: 'MONTHLY',
	EVERY_3_MONTHS: 'EVERY_3_MONTHS',
	EVERY_6_MONTHS: 'EVERY_6_MONTHS',
	YEARLY: 'YEARLY',
};

export const STRIPE_INTERVAL = {
	DAY: 'day',
	MONTH: 'month',
	WEEK: 'week',
	YEAR: 'year',
};

export const BILLING_LABELS = {
	MONTHLY: 'Total Monthly Cost',
	QUARTERLY: 'Quarterly Cost',
	HALF_YEARLY: 'Half-Yearly Cost',
	YEAR: 'Annual Cost',
};

export const BILLING_PERIODS = [
	{
		label: 'Daily',
		value: BILLING_PERIOD.DAILY,
	},
	{
		label: 'Weekly',
		value: BILLING_PERIOD.WEEKLY,
	},
	{
		label: 'Monthly',
		value: BILLING_PERIOD.MONTHLY,
	},
	{
		label: 'Every 3 months',
		value: BILLING_PERIOD.EVERY_3_MONTHS,
	},
	{
		label: 'Every 6 months',
		value: BILLING_PERIOD.EVERY_6_MONTHS,
	},
	{
		label: 'Yearly',
		value: BILLING_PERIOD.YEARLY,
	},
];

export const MIN_PAGE_CONTAINER_WIDTH = {
	DEFAULT_PAGE_WIDTH: 1441,
};

export const MIN_WIDTH_CONTAINER_CLASS = {
	PAGE_WIDTH_DEFAULT_CLASS: 'pages_container_default_width',
};

export const PAGE_SIZE = {
	USERS_LIST_CACHE: 500,
};

export const BIDS_TABLE_COLUMNS = [
	'statusDisplay',
	'businessName',
	'truckLocation',
	'allInPrice',
	'pickupDate',
	'deliveryDate',
	'readOrResponded',
	'actions',
];

export const OUT_OF_NETWORK_DELAY = 30;

export const USER_SORTS_AND_FILTERS_TYPE = {
	PROJECTS: 'PROJECTS',
	PROCUREMENT: 'PROCUREMENT',
	WORKFLOWS: 'WORKFLOWS',
	LOADS: 'LOADS',
	OFFERS: 'OFFERS',
};

export const QUALITY_SCORE_DISPLAY = {
	HIGH: 'High',
	MEDIUM: 'Medium',
	LOW: 'Low',
};

export const QUALITY_FILTER_OPTIONS = [
	{ value: '', label: 'All' },
	{ value: QUALITY_SCORE_DISPLAY.HIGH, label: QUALITY_SCORE_DISPLAY.HIGH },
	{ value: QUALITY_SCORE_DISPLAY.MEDIUM, label: QUALITY_SCORE_DISPLAY.MEDIUM },
	{ value: QUALITY_SCORE_DISPLAY.LOW, label: QUALITY_SCORE_DISPLAY.LOW },
];

export const OFFER_RATE_CONFIRMATION = {
	TITLE: 'Confirm Offer Rate Change',
	MESSAGE:
		'Setting the Offer Rate to $0 means all carriers without a procured rate for this project will get load offers with no rate for this lane.',
	CANCEL: 'Cancel',
	CONFIRM: 'Confirm',
};
